
<div class="row">
  <div class="col-md-12">
    <h2>Dealer Report Log</h2>
  </div>
</div>
<div class="row">
  <div class="col-sm-6 col-md-3 col-xl-2">
      <div class="form-group">
        <label for="selectedYear">Viewing Year</label>
        <select id="selectedYear" name="selectedYear" [(ngModel)]="selectedYear" (ngModelChange)="selectYear($event)"
                class="form-control form-control-sm">
          <option *ngFor="let year of selectableYears" [ngValue]="year">{{year}}</option>
        </select>
      </div>
  </div>
  <div class="col-sm-6 col-md-4 col-xl-3" [ngSwitch]="areUpcomingVisible()">
    <button *ngSwitchCase="false" class="btn btn-sm btn-block btn-primary upcomingWeekButton" (click)="toggleUpcoming()">Show
      upcoming weeks</button>
    <button *ngSwitchCase="true" class="btn btn-sm btn-block btn-danger upcomingWeekButton" (click)="toggleUpcoming()">Hide
      upcoming weeks</button>
  </div>
  <div *appHasAuthority="'MANAGE_MY_REPORT'" class="col-sm-12 col-md-4 col-xl-3">

    <button class="btn btn-primary btn-sm btn-block addReportButton" (click)="addPurchase()">
      <i class="fas fa-plus"> </i>&nbsp;Add a Purchase
    </button>
  </div>
  <div *appHasAuthority="'MANAGE_REPORT'" class="col-sm-12 col-md-4 col-xl-3">
    <button class="btn btn-primary btn-sm btn-block addReportButton" (click)="addPaperReport()">
      <i class="fas fa-plus"> </i>&nbsp;Add Paper Report
    </button>
  </div>
  <div *appHasAuthority="'MANAGE_REPORT'" class="col-sm-12 col-md-4 col-xl-3">
    <button class="btn btn-primary btn-sm btn-block addReportButton" (click)="addPaperCredit()">
      <i class="fas fa-plus"> </i>&nbsp;Add Paper Credit
    </button>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <table class="table table-bordered table-responsive-sm">
      <thead class="thead-dark">
      <tr>
        <th width="30%">Reporting Period</th>
        <th width="20%">Status</th>
        <th width="15%">Completion Date</th>
        <th width="20%">Report Type</th>
        <th width="15%">Citations</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let period of filteredReportingPeriods; let i=index">
        <tr class="ng-hide" [ngClass]="{ 'table-danger': period.status == ReportStatus.PAST_DUE, 'table-secondary': !period.isCurrent()}">
          <td>
            <a [routerLink]="" (click)="openPeriod(i)">
              <i class="fas fa-folder" [ngClass]="{'fa-folder':  !selectedWeeks.includes(i), 'fa-folder-open': selectedWeeks.includes(i)}">
              </i>
              ({{period.weekOfYear}}) {{period.start | date:'mediumDate'}} - {{period.lastDay() |
              date:'mediumDate'}}
            </a>
            <i *ngIf="selectedWeeks.includes(i) && loading == i" class="fa fa-spinner fa-spin"></i>
          </td>
          <td [ngSwitch]="period.status">
            <ng-container *ngSwitchCase="ReportStatus.PAST_DUE">
              <i class="fas fa-clock text-danger"> </i>&nbsp;<strong>Past Due</strong>
            </ng-container>
            <ng-container *ngSwitchCase="ReportStatus.PENDING">
              <strong>Due on {{period.dueDate | date:'mediumDate'}}</strong>
            </ng-container>
            <ng-container *ngSwitchCase="ReportStatus.SUBMITTED">
              <i class="fas fa-check text-success"></i>&nbsp;<strong>Submitted</strong>
            </ng-container>
          </td>
          <td>
            <ng-container *ngIf="period.status == ReportStatus.SUBMITTED">{{period.completion |
              date:'mediumDate'}}</ng-container>
          </td>
          <td>
            <ng-container *ngIf="period.status == ReportStatus.SUBMITTED">
                  <span *ngFor="let reportType of period.reportedTypes; last as isLast">
                    <ng-container [ngSwitch]="reportType">
                      <strong *ngSwitchCase="ReportedType.DNP" class="rpt-tp-dnp">DNP</strong>
                      <strong *ngSwitchCase="ReportedType.P" class="rpt-tp-purchase">Purchase</strong>
                      <strong *ngSwitchCase="ReportedType.PAQ" class="rpt-tp-purchase-aq">Purchase-AQ</strong>
                    </ng-container>
                    <ng-container *ngIf="!isLast">, </ng-container>
                  </span>
            </ng-container>
          </td>
          <td>
             <span *ngFor="let citation of period.citationNumbers; last as isLast">
               <a href="{{appSettings.citationURL}}?citationNumber={{citation.substring(5)}}" target="_blank">{{citation}}</a><ng-container *ngIf="!isLast">, </ng-container>
             </span>
          </td>
        </tr>
        <tr *ngIf="loading !== i && selectedWeeks.includes(i)">
          <td colspan="5" [ngSwitch]="period.status">
            <div class="responsive-table-cell">
            <ng-container *ngSwitchCase="ReportStatus.PAST_DUE">
              <div>
                <div class="alert alert-danger" role="alert">
                  <i class="fas fa-exclamation-triangle"> </i>
                  <span>This report is past due. Please submit your purchase information for this week
                        immediately.</span>
                </div>
              </div>
              <ng-container *ngTemplateOutlet="listOfReports; context:  {$implicit: period.purchaseReports, index: i}"></ng-container>

              <ng-container *appHasAuthority="'MANAGE_MY_REPORT'">
                <button *ngIf="period.isCurrent()" class="btn btn-primary btn-sm mr-1" (click)="addPurchase(i)"
                        aria-hidden="false">
                  <i class="fas fa-plus"> </i>&nbsp;Add a Purchase
                </button>
              </ng-container>

              <ng-container *appHasAuthority="'MANAGE_MY_REPORT'">
                <button *ngIf="period.reportedTypes.size === 0 || hasManageReportAuthority()" class="btn btn-danger btn-sm mr-1" (click)="didNotPurchase(i)">
                  <i class="fas fa-ban"> </i>&nbsp;Did Not Purchase
                </button>
              </ng-container>

              <ng-container *appHasAuthority="'MANAGE_REPORT'">
                <button *ngIf="period.isCurrent()" class="btn btn-primary btn-sm mr-1" (click)="addPaperReport(i)">
                  <i class="fas fa-plus"> </i>&nbsp;Add a Paper Purchase Report
                </button>
              </ng-container>

              <ng-container *appHasAuthority="'MANAGE_REPORT'">
                <button *ngIf="period.reportedTypes.size === 0 || hasManageReportAuthority()" class="btn btn-danger btn-sm mr-1" (click)="didNotPurchaseWithoutWarning(i)">
                  <i class="fas fa-ban"> </i>&nbsp;Did Not Purchase
                </button>
              </ng-container>

              <ng-container *appHasAuthority="'MANAGE_REPORT'">
                <button *ngIf="period.isCurrent()" class="btn btn-primary btn-sm mr-1" (click)="addPaperCredit(i)">
                  <i class="fas fa-plus"> </i>&nbsp;Add Paper Credit
                </button>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="ReportStatus.PENDING">
              <div *appHasAuthority="'MANAGE_MY_REPORT'">
                <p>
                  <strong><i>Add a Purchase</i></strong> to report purchase information or submit a <strong><i>Did
                  Not Purchase</i></strong> report for this week.
                </p>
              </div>
              <ng-container *ngTemplateOutlet="listOfReports; context:  {$implicit: period.purchaseReports, index: i}"></ng-container>

              <ng-container *appHasAuthority="'MANAGE_MY_REPORT'">
                <button *ngIf="period.isCurrent()" class="btn btn-primary btn-sm mr-1" (click)="addPurchase(i)"
                        aria-hidden="false">
                  <i class="fas fa-plus"> </i>&nbsp;Add a Purchase
                </button>
              </ng-container>

              <ng-container *appHasAuthority="'MANAGE_MY_REPORT'">
                <button *ngIf="period.reportedTypes.size === 0 || hasManageReportAuthority()" class="btn btn-danger btn-sm mr-1" (click)="didNotPurchase(i)">
                  <i class="fas fa-ban"> </i>&nbsp;Did Not Purchase
                </button>
              </ng-container>

              <ng-container *appHasAuthority="'MANAGE_REPORT'">
                <button *ngIf="period.isCurrent()" class="btn btn-primary btn-sm mr-1" (click)="addPaperReport(i)">
                  <i class="fas fa-plus"> </i>&nbsp;Add a Paper Purchase Report
                </button>
              </ng-container>

              <ng-container *appHasAuthority="'MANAGE_REPORT'">
                <button *ngIf="period.reportedTypes.size === 0 || hasManageReportAuthority()" class="btn btn-danger btn-sm mr-1" (click)="didNotPurchaseWithoutWarning(i)">
                  <i class="fas fa-ban"> </i>&nbsp;Did Not Purchase
                </button>
              </ng-container>

              <ng-container *appHasAuthority="'MANAGE_REPORT'">
                <button *ngIf="period.isCurrent()" class="btn btn-primary btn-sm mr-1" (click)="addPaperCredit(i)">
                  <i class="fas fa-plus"> </i>&nbsp;Add Paper Credit
                </button>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="ReportStatus.SUBMITTED">
              <p class="text-danger" *ngIf="period.reportedTypes.has(ReportedType.DNP) && period.reportedTypes.size===1">
                <strong>DID NOT PURCHASE report entered for this week. To remove the Did Not Purchase report, add a purchase.</strong>
              </p>
              <ng-container *ngTemplateOutlet="listOfReports; context:  {$implicit: period.purchaseReports, index: i}"></ng-container>
              <div *appHasAuthority="'MANAGE_MY_REPORT'">
                <button *ngIf="period.isCurrent()" class="btn btn-primary btn-sm mr-1" (click)="addPurchase(i)"
                        aria-hidden="false">
                  <i class="fas fa-plus"></i>&nbsp;Add a Purchase
                </button>
              </div>
              <div *appHasAuthority="'MANAGE_REPORT'">
                <button *ngIf="period.isCurrent()" class="btn btn-primary btn-sm mr-1" (click)="addPaperReport(i)">
                  <i class="fas fa-plus"> </i>&nbsp;Add a Paper Purchase Report
                </button>
                <button class="btn btn-danger btn-sm mr-1" (click)="didNotPurchaseWithoutWarning(i)">
                  <i class="fas fa-ban"> </i>&nbsp;Did Not Purchase
                </button>
                <button *ngIf="period.isCurrent()" class="btn btn-primary btn-sm mr-1" (click)="addPaperCredit(i)">
                  <i class="fas fa-plus"> </i>&nbsp;Add Paper Credit
                </button>
              </div>
            </ng-container>
            </div>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
</div>

<ng-template #listOfReports let-purchaseReports let-periodIndex="index">
  <div>
    <ng-container *ngIf="loading !== periodIndex && purchaseReports as reports">

      <table *ngIf="reports?.length" class="table">
        <thead class="thead-dark">
        <tr>
          <th>Date</th>
          <th>Fisher</th>
          <th>License #</th>
          <th>Amount</th>
          <th>Type</th>
          <th>Submitted By</th>
          <th>Submitted On</th>
          <th *appHasAuthority="'DEALER_INFO'">Approval Status</th>
          <th class="buttons-column">Action</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let report of reports">
          <tr>
            <td>{{report.reportDate | date:'mediumDate'}}</td>
            <td>{{report.sellerName}}</td>
            <td>{{report.sellerId}}</td>
            <td class="text-right">{{report.amount | bigCurrency}}</td>
            <td>
              <ng-container [ngSwitch]="report.reportType">
                <strong *ngSwitchCase="ReportType.P">Purchase</strong>
                <strong *ngSwitchCase="ReportType.PAQ">Purchase-AQ</strong>
              </ng-container>
            </td>
            <td>{{report.submittedBy}}</td>
            <td>{{report.submittedOn | date:'mediumDate'}}</td>
            <td *appHasAuthority="'DEALER_INFO'">
              <strong *ngIf="report.deleted" class="rpt-tp-dnp">DELETED</strong>
              <ng-container *ngIf="!report.deleted">
                <select *appHasAuthority="'MANAGE_REPORT'" class="form-control form-control-sm"  aria-label="status"
                        (change)="onStatusChange(report.id, $event.target.value)">
                  <option></option>
                  <option [selected]="ApprovalStatus.APPROVED == report.status" [value]="ApprovalStatus[ApprovalStatus.APPROVED]">{{ApprovalStatus.meaning(ApprovalStatus.APPROVED)}}</option>
                  <option [selected]="ApprovalStatus.PENDING == report.status" [value]="ApprovalStatus[ApprovalStatus.PENDING]">{{ApprovalStatus.meaning(ApprovalStatus.PENDING)}}</option>
                  <option [selected]="ApprovalStatus.NO_RESPONSE == report.status" [value]="ApprovalStatus[ApprovalStatus.NO_RESPONSE]">{{ApprovalStatus.meaning(ApprovalStatus.NO_RESPONSE)}}</option>
                </select>
                <span *appHasNoAuthority="'MANAGE_REPORT'">{{ApprovalStatus.meaning(report.status)}}</span>
              </ng-container>
            </td>
            <td>
              <div class="odr-btn-group" role="group" aria-label="Report actions">
                <button (click)="openPurchaseReceiptReport(report.id, report.submittedBy, periodIndex)" class="btn btn-primary btn-sm mr-1"><i class="far fa-eye"> </i> <span *appHasNoAuthority="'DEALER_INFO'"> View report</span><span *appHasAuthority="'DEALER_INFO'"> View</span></button>
                <ng-container *appHasAuthority="'MANAGE_REPORT'">
                  <button *ngIf="!report.deleted" (click)="deleteReceiptReport(report.id, periodIndex)" class="btn btn-danger btn-sm"><i class="fas fa-trash"> </i> Delete </button>
                </ng-container>
              </div>
            </td>
          </tr>
          <tr *ngIf="showDeleteWarning == report.id" class="alert alert-danger">
            <td colspan="9">
              <div >
                <span>Are you sure you want to delete this report? To confirm, click delete again.</span>
              </div>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </ng-container>
  </div>
</ng-template>
